import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { StyledCanvaPricing } from "./canva-pricing-style";
import { TextInput } from "../../components/text-input/TextInput";
import { Button } from "../../components/button/Button";
import { ItemType } from "../../types";
import { formatPrice, itemToDefaultPrice, itemToDefaultTokens } from "../../utils/pricing";
import { getLocalizedPath } from "../../utils/lang";
import CanvaXIllustrokeLogo from "../../images/canva.png";
import { Trans, useTranslation } from "react-i18next";

export const CanvaPricing = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("id");
  const [email, setEmail] = useState<string>("");

  const handleBuy = (item: ItemType) => {
    if (!email || !email.includes("@")) {
      alert("Please enter a valid email address");
      return;
    }

    navigate(getLocalizedPath('/checkout'), { 
      state: { 
        item,
        canvaEmail: email,
        canvaUserId: userId
      } 
    });
  };

  return (
    <>
      <Helmet>
        <title>Illustroke | Canva Pricing</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <StyledCanvaPricing>

        <img width={250} src={CanvaXIllustrokeLogo} alt="Canva X Illustroke Logo" className="logo" />

        <div>
          <h1>{t("pricing_subtitle")}</h1>
          <p className="subtitle">Purchase tokens to create amazing illustrations</p>
        </div>

        <div className="email-section">
          <label htmlFor="email">Your email Address</label>
          <TextInput
            id="email"
            type="email"
            name="email"
            placeholder="your@email.com"
            value={email}
            onChange={(e: any) => setEmail(e.target.value)}
          />
        </div>

        <div className="bundles">
          <div className="bundle">
            <h2>Personal</h2>
            <p className="tokens">{itemToDefaultTokens("personal")} tokens</p>
            <Button onClick={() => handleBuy("personal")}>
              Buy for {formatPrice(itemToDefaultPrice("personal"))}
            </Button>
          </div>

          <div className="bundle">
            <h2>Growth</h2>
            <p className="tokens">{itemToDefaultTokens("growth")} tokens</p>
            <Button onClick={() => handleBuy("growth")}>
              Buy for {formatPrice(itemToDefaultPrice("growth"))}
            </Button>
          </div>
        </div>

        <div className="howitworks">
          <h1>{t("pricing_how_it_works_title")}</h1>
          <p><Trans i18nKey="pricing_how_it_works_desc" components={{ b: <b /> }} /></p>
        </div>

        <div className="Nosub">
          <h1>{t("pricing_no_sub_title")}</h1>
          <p><Trans i18nKey="pricing_no_sub_desc" components={{ b: <b /> }} /></p>
        </div>

      </StyledCanvaPricing>
    </>
  );
};
